import type { MultiIdComboboxOption } from '@/components/ui/multi-id-combobox';
import { MultiIdCombobox } from '@/components/ui/multi-id-combobox';
import type { ResourceThreatChecklists } from 'components/IAP/hooks/resourceSetHooks';
import { useOrgEventAutomationRules } from 'hooks/orgEvents/orgEventAutomationHooks';
import { NULL_VALUE } from 'constants/displayConstants';
import { ChecklistConfigEditor } from '../EventsTab/ChecklistConfigEditor';

export function formatResourceThreats(threats: string[] | undefined): string {
  if (!threats?.length) return NULL_VALUE;
  return threats.join(', ');
}

export function formatAutomationRules(rules: string[] | undefined): string {
  return formatResourceThreats(rules);
}

export function ResourceAutomationRulesMultiSelect({
  value,
  onChange,
}: {
  value: string[];
  onChange: (next: string[]) => void;
}) {
  const { data: rules = [] } = useOrgEventAutomationRules();
  const options = rules
    .filter((rule) => !rule.archived)
    .map((rule) => ({ value: rule.name, label: rule.name }));
  const extra = value
    .filter((name) => !options.some((option) => option.value === name))
    .map((name) => ({ value: name, label: name }));

  return (
    <MultiIdCombobox
      options={[...options, ...extra]}
      value={value}
      onChange={onChange}
      placeholder="Select automation rules"
    />
  );
}

/** @deprecated Use ResourceAutomationRulesMultiSelect */
export const ResourceThreatsMultiSelect = ResourceAutomationRulesMultiSelect;

export function ResourceAutomationRuleChecklistsFields({
  selectedRuleNames,
  checklists,
  onRulesChange,
  onChecklistsChange,
  userOptions,
  teamOptions,
}: {
  selectedRuleNames: string[];
  checklists: ResourceThreatChecklists;
  onRulesChange: (next: string[]) => void;
  onChecklistsChange: (next: ResourceThreatChecklists) => void;
  userOptions: MultiIdComboboxOption[];
  teamOptions: MultiIdComboboxOption[];
}) {
  return (
    <div className="tw:space-y-3">
      <ResourceAutomationRulesMultiSelect
        value={selectedRuleNames}
        onChange={onRulesChange}
      />
      {selectedRuleNames.map((ruleName) => (
        <div key={ruleName} className="tw:space-y-1">
          <div className="fw-semibold tw:text-sm">
            Response Checklist — {ruleName}
          </div>
          <ChecklistConfigEditor
            items={checklists[ruleName] ?? []}
            onChange={(next) =>
              onChecklistsChange({
                ...checklists,
                [ruleName]: next,
              })
            }
            userOptions={userOptions}
            teamOptions={teamOptions}
          />
        </div>
      ))}
    </div>
  );
}
